import { Toolbox as Value } from "@reactivated";

import { StreamFieldBlockMap } from "@thelabnyc/thelabui/src/components/StreamField";

import { AccordionBlock } from "../../AccordionBlock";
import { ArticleSlidesBlockWrapper } from "../../ArticleSlidesBlock";
import { BlockGroup } from "../../BlockGroup";
import { CardGridBlock } from "../../CardGridBlock";
import { AnimatedCarousel } from "../../Carousel/AnimatedCarousel";
import { CenterFocusedCarouselBlock } from "../../CenterFocusedCarouselBlock";
import { CenteredHeroBlock } from "../../CenteredHero";
import { CompactSplitBlockWrapper } from "../../CompactSplitBlock";
import { ContactSubscribeBlock } from "../../ContactSubscribeBlock";
import { DualImageSplitBlock } from "../../DualImageSplitBlock";
import { FlipbookBlock } from "../../FlipbookBlock";
import { FormBlock, SplitFormBlock } from "../../FormBlock";
import { FullContainerMediaBlock } from "../../FullContainerMediaBlock";
import { FullWidthHeroBlock } from "../../FullWidthHeroBlock";
import { FullWidthImageBlock } from "../../FullWidthImageBlock";
import { GridBlock } from "../../GridBlock";
import { HeroCarouselBlock } from "../../HeroCarouselBlock";
import {
    ImageBackgroundBlock,
    ImageBackgroundCarouselBlock,
} from "../../ImageBackground";
import { ImageTextSlides } from "../../ImageTextSlides";
import { LocatorMapBlock } from "../../LocatorMapBlock";
import { LogoRow } from "../../LogoRow";
import { ModalVideoHeroBlock } from "../../ModalVideoHero";
import { MultiBrowseBlockWrapper } from "../../MultiBrowseBlock";
import { PeopleBlock } from "../../PeopleBlock";
import { ProductHotspots } from "../../ProductHotspots";
import { ReusableContentBlock } from "../../ReusableContent";
import { RichTextBlock } from "../../RichTextBlock";
import { RichTextSectionBlock } from "../../RichTextSectionBlock";
import { ShowroomLocationsGalleryBlock } from "../../ShowroomLocationsGalleryBlock";
import { SmallLinkTilesWrapper } from "../../SmallLinkTilesBlock";
import { SpacerLegacyBlock } from "../../SpacerBlock";
import { SpacerBlockThemed } from "../../SpacerBlock/SpacerBlock";
import { SplitBlock, SplitCarouselBlock } from "../../SplitBlock";
import { StepByStepBlock } from "../../StepByStepBlock";
import { SuiteBuilderPromoBlock } from "../../SuiteBuilderPromoBlock";
import { SumoBlock } from "../../SumoBlock";
import { TextListBlock } from "../../TextListBlock";
import { ThreeUpCardsBlock } from "../../ThreeUpCardsBlock";
import { TwoUpCaptionBlock } from "../../TwoUpCaptionBlock";
import { TwoUpCardsBlock } from "../../TwoUpCardsBlock";
import { TwoUpNavigationBlock } from "../../TwoUpNavigationBlock";
import { ValuePropsBlock } from "../../ValueProps";

export const toolboxComponents: StreamFieldBlockMap<Value> = {
    accordion: AccordionBlock,
    animated_carousel: AnimatedCarousel,
    article_slides: ArticleSlidesBlockWrapper,
    block_group: BlockGroup,
    card_grid: CardGridBlock,
    center_focused_carousel: CenterFocusedCarouselBlock,
    centered_hero: CenteredHeroBlock,
    compact_split: CompactSplitBlockWrapper,
    contact_subscribe: ContactSubscribeBlock,
    dual_image_split: DualImageSplitBlock,
    flipbook: FlipbookBlock,
    form: FormBlock,
    full_container_media: FullContainerMediaBlock,
    full_width: FullWidthImageBlock,
    full_width_hero: FullWidthHeroBlock,
    grid: GridBlock,
    hero_carousel: HeroCarouselBlock,
    image_background: ImageBackgroundBlock,
    image_background_carousel: ImageBackgroundCarouselBlock,
    image_text_slides: ImageTextSlides,
    locator_map: LocatorMapBlock,
    logo_row: LogoRow,
    modal_video_hero: ModalVideoHeroBlock,
    multi_browse: MultiBrowseBlockWrapper,
    people: PeopleBlock,
    product_hotspots: ProductHotspots,
    reusable_content: ReusableContentBlock,
    rich_text: RichTextBlock,
    spacer: SpacerLegacyBlock,
    spacer_2026_themed: SpacerBlockThemed,
    split: SplitBlock,
    split_form: SplitFormBlock,
    split_carousel: SplitCarouselBlock,
    step_by_step: StepByStepBlock,
    showroom_locations_gallery: ShowroomLocationsGalleryBlock,
    small_link_tiles: SmallLinkTilesWrapper,
    suite_builder_promo: SuiteBuilderPromoBlock,
    text_list: TextListBlock,
    three_up_cards: ThreeUpCardsBlock,
    two_up_caption: TwoUpCaptionBlock,
    two_up_cards: TwoUpCardsBlock,
    two_up_navigation: TwoUpNavigationBlock,
    value_props: ValuePropsBlock,
    rich_text_stream: RichTextSectionBlock,
    sumo: SumoBlock,
};
